<template>
  <li class="icon-list-item flex" :class="`items-${alignItems}`">
    <span
      :class="[
        'label caption-regular text-secondary-secondary flex gap-050',
        labelClass,
        `items-${alignItems}`,
      ]"
    >
      <LcIcon :name="icon" size="small" />
      <span>{{ `${label}:` }}</span>
    </span>

    <div :class="['w-full caption-bold', valueClass]">
      <slot />
    </div>
  </li>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

export type IconListItemProps = {
  alignItems?: 'center' | 'start'
  icon: LcIconName
  label: string
  labelClass?: string
  valueClass?: string
}

const { alignItems = 'center' } = defineProps<IconListItemProps>()
</script>

<style lang="scss" scoped>
.icon-list-item {
  .label {
    min-width: 7.25rem;
  }
}
</style>
